import React, { ReactNode } from "react";

import NavigationLink from "../navigationLink/navigationLink";

import "./megaMenuResult.scss";

interface MegaMenuResultProps {
  href: string;
  image: ReactNode;
  children: ReactNode;
}

const MegaMenuResult: React.FC<MegaMenuResultProps> = ({ href, image, children }) => (
  <NavigationLink
    href={href}
    className="megamenu-result"
  >
    {image}
    <span className="typo-label">{children}</span>
  </NavigationLink>
);

export default MegaMenuResult;
